import { plaintextValidator, dropdownValidator } from '../fields';
import { stringMandateConstraints } from '../utils';

const config = { mandatory: true };

export const contractTemplateConstraints = {
  name: plaintextValidator(config),
  selectedItems: {
    array: {
      ['frequency.type']: stringMandateConstraints,
      // subscriptionType: stringMandateConstraints,
      unitPrice: plaintextValidator(config)
    }
  },
  selectedCustomItems: {
    array: {
      discountRate: stringMandateConstraints
    }
  }
};
